import React, { useState } from "react";
import { useEffect } from "react";
import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Input,
  Select,
  Text,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
} from "@chakra-ui/react";

import Avatar from "../assets/images/avatar.png";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { unwrapResult } from "@reduxjs/toolkit";
import { SignOut, SignOutAll, getUserDetails } from "../redux/auth/AuthSlice";
import { getCompanyDetails } from "../redux/company/CompanySlice";
import jwt_decode from "jwt-decode";
import isAllowed from "../routing/isAllowed";
import ScopeRenewalModal from "../Components/Account/ScopeRenewalModal";
import ScopeExtensionModal from "../Components/Account/ScopeExtensionModal";

function Account() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const { userData } = useSelector((state) => state.auth);
  const { companyDetails } = useSelector((state) => state.company);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);

  const getUserData = () => {
    try {
      const result = dispatch(getCompanyDetails(userData.companyId));
      unwrapResult(result);
    } catch (error) {
      unwrapResult(error);
    }
  };

  const [open, setOpen] = useState(false);
  const [secOpen, setSecOpen] = useState(false);

  const onSecModalCLose = () => setSecOpen(false);

  const onModalClose = () => setOpen(false);

  useEffect(() => {
    getUserData();
  }, []);

  return (
    <>
      <Box marginBottom={"1rem"} p="1rem">
        <Box
          mt="1rem"
          bg="white"
          p="2rem"
          borderRadius="15px"
          boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
        >
          <Flex justifyContent={"space-between"} alignItems="center">
            <Box marginTop="2rem">
              <Text
                color={"#141D43"}
                fontSize="2xl"
                fontWeight={"800"}
                fontFamily={"font.roboto"}
              >
                <Box
                  as="span"
                  borderRight={"5px solid #2272D5"}
                  height="40px"
                  marginRight={"1rem"}
                ></Box>
                Account
              </Text>
            </Box>
          </Flex>
          <Box mt="2rem">
            <Grid templateColumns="repeat(2, 1fr)" marginTop={"1rem"}>
              <GridItem colSpan={1}>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Name
                </Text>

                <Text marginTop="10px">{userData?.name}</Text>
              </GridItem>
            </Grid>
          </Box>
          <Box>
            <Grid templateColumns="repeat(2, 1fr)" marginTop={"1rem"}>
              <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Email
                </Text>
                <Text marginTop="10px">{userData?.email}</Text>
              </GridItem>
              <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Contact Number
                </Text>
                <Text marginTop="10px">{userData?.phone}</Text>
              </GridItem>
            </Grid>
          </Box>
          <Box>
            <Grid marginTop={"1rem"}>
              <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Address
                </Text>
                <Text mt="10px">
                  {companyDetails?.data?.address?.raw_address}
                </Text>
              </GridItem>
            </Grid>
          </Box>
          <Box>
            <Grid templateColumns="repeat(3, 1fr)" marginTop={"1rem"}>
              <GridItem colSpan={1}>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  City
                </Text>
                <Text mt="10px">{companyDetails?.data?.address?.city}</Text>
              </GridItem>
              <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  State
                </Text>
                <Text mt="10px">{companyDetails?.data?.address?.state}</Text>
              </GridItem>
              <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Company
                </Text>
                <Text mt="10px">{companyDetails?.data?.name}</Text>
              </GridItem>
            </Grid>
          </Box>
          <Box>
            <Grid marginTop={"1rem"} templateColumns="repeat(2, 1fr)">
              <GridItem colSpan={1}>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  License Number
                </Text>
                <Text mt="10px">{companyDetails?.data?.license}</Text>
              </GridItem>
              <GridItem colSpan={1}>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Product/Products approved
                </Text>
                <Text mt="10px">
                  {companyDetails?.data?.company_products?.map((product) => (
                    <Text as="span" key={product.id}>
                      {product.name},{" "}
                    </Text>
                  ))}
                </Text>
              </GridItem>
            </Grid>
          </Box>
          <Box>
            <Box marginTop="2rem">
              <AlertDialog isOpen={secOpen} onClose={onSecModalCLose}>
                <AlertDialogOverlay />
                <AlertDialogContent>
                  <AlertDialogHeader>Are you sure?</AlertDialogHeader>
                  <AlertDialogBody>Do you want to continue?</AlertDialogBody>
                  <AlertDialogFooter>
                    <Button onClick={onSecModalCLose} marginRight="2rem">
                      Cancel
                    </Button>

                    <Button
                      w="130px"
                      onClick={() => {
                        dispatch(SignOutAll());
                        navigate("/signin", { replace: true });
                      }}
                      bg="crimson"
                      color={"#fff"}
                      _hover={{ bg: "crimson" }}
                    >
                      Confirm
                    </Button>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialog>
              <Flex gap="1rem">
                <Button
                  w="250px"
                  onClick={() => {
                    setSecOpen(true);
                  }}
                  bg="crimson"
                  color={"#fff"}
                  _hover={{ bg: "crimson" }}
                >
                  Sign out from all sessions
                </Button>
                <Button
                  w="200px"
                  bg="blue"
                  color={"#fff"}
                  _hover={{ bg: "blue" }}
                  onClick={() => setModalOpen(true)}
                >
                  Scope renewal
                </Button>
                <Button
                  w="200px"
                  bg="#A8BF87"
                  color={"#fff"}
                  _hover={{ bg: "#A8BF87" }}
                  onClick={() => setIsSecondModalOpen(true)}
                >
                  Scope extension
                </Button>
              </Flex>
            </Box>
          </Box>
        </Box>
      </Box>
      <ScopeRenewalModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        userData={userData}
        companyDetails={companyDetails?.data}
      />
      <ScopeExtensionModal
        isOpen={isSecondModalOpen}
        onClose={() => setIsSecondModalOpen(false)}
        userData={userData}
        companyDetails={companyDetails?.data}
      />
    </>
  );
}

export default isAllowed(Account);
